module.exports = function() {
  return new Worker(__webpack_public_path__ + "9e0875fc690b06765c74.worker.js");
};